import { contentType } from "./types";

const ALL: contentType = {
    logo: `logo`,
    menu: `menu`,

    instruction: `Instruction`,
    upload: `Upload image`
}

export default function getContantPage(): contentType {
    return ALL;
}
